import { createContext } from 'react';

import { ContextValue } from './types';

const IsPlanWorkflowModalOpenContext = createContext<ContextValue | null>(null);

export default IsPlanWorkflowModalOpenContext;
